import { updateClientConstants } from './update-client.constants'

const initialState = {
	client: null,
	isFetching: false
}

function updateClientReducer(state = initialState, { type, payload, errors }) {
	switch (type) {
		case updateClientConstants.GET_CLIENT:
			return {
				...state,
				isFetching: true
			}
		case updateClientConstants.SET_CLIENT:
			return {
				...state,
				isFetching: false,
				client: payload
			}

		case updateClientConstants.UPDATE_CLIENT:
			return {
				...state,
				isUpdating: true
			}

		case updateClientConstants.CLIENT_UPDATED:
			return {
				...state,
				isUpdating: false,
				errors
			}

		case updateClientConstants.UPDATE_ADDRESSES:
			state.client.addresses = payload
			return {
				...state
			}

		default:
			return state
	}
}

export { updateClientReducer as Reducer }
